module.exports = __webpack_public_path__ + "/login_ui/img/ki-92b1877573bc8a889b7ae4e8e3e5a973.svg";